import { Component, OnInit, ViewChild,ElementRef } from '@angular/core';
import { SharedService } from '../../../_service/shared.service';
import { LeadsService } from '../../../_service/leads.service';
import {PageEvent, MatPaginator} from '@angular/material/paginator';
import {MatDialog} from '@angular/material/dialog';

@Component({
  selector: 'app-insurance-tracker-list',
  templateUrl: './insurance-tracker-list.component.html',
  styleUrls: ['./insurance-tracker-list.component.css']
})
export class InsuranceTrackerListComponent implements OnInit {
  perpage:number=25;length:number=0;pageEvent: PageEvent;loading:boolean=true;myrole:string;pageSizeOptions = [10,25,50,100,200];pageIndex:number=0;loaded:boolean=false;

  leads = [];start_date:string='';end_date:string='';search:string;
  @ViewChild('dateRangeStart', {static: false}) dateRangeStart: ElementRef;
  @ViewChild('dateRangeEnd', {static: false}) dateRangeEnd: ElementRef;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  constructor(private leadapi:LeadsService, private sharedapi:SharedService,private dialog:MatDialog) { }

  ngOnInit(): void {
    this.sharedapi.getRole()
    .subscribe((item:string) => {this.myrole=item;});
    this.myrole = localStorage.getItem('role');
  }
  ngAfterViewInit() {
    this.loadInsuranceTrackList(0,this.perpage);
  }

  loadInsuranceTrackList(pageIndex,perpage)
  {
      this.leads = [];
      this.paginator.pageIndex = pageIndex; 
      let qString = 'search='+this.search+'&date_range='+this.start_date+'-'+this.end_date;
      this.loading = true;this.loaded = false;
      this.leadapi.getInsuranceListForTracking(this.paginator.pageIndex,perpage,qString).subscribe((data:any) => {
          this.length = parseInt(data.totaldata);
          this.loading = false;
          this.loaded = true;
          if(data.status)
          {
            console.log(data.data)
              this.leads = data.data;
          }else{
              this.leads = [];
          }
      }, error => {
          this.loading = false;
          this.loaded = true;
          this.sharedapi.checkError(error);
      });
  }

  public getServerData(event:PageEvent):any
  {
      this.perpage = event.pageSize;
      this.pageIndex = event.pageIndex;
      this.loadInsuranceTrackList(event.pageIndex,event.pageSize);
  }

  dateRangeChange(date1,date2)
  {
      if(date2.value)
      {
          this.start_date = date1.value;
          this.end_date = date2.value;
          this.loadInsuranceTrackList(0,this.perpage);
      }
  }
  
  clearDate()
  {
      this.dateRangeStart.nativeElement.value = "";
      this.dateRangeEnd.nativeElement.value = "";
      this.start_date = '';
      this.end_date = '';
      this.loadInsuranceTrackList(0,this.perpage);
  }

}
